/**
 * @generated SignedSource<<53ec7b78b261cac5271cdf039081cb44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionActionCompletePurchase_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyItNowButton_user">;
  readonly " $fragmentType": "PdpSharedAuctionActionCompletePurchase_user";
};
export type PdpSharedAuctionActionCompletePurchase_user$key = {
  readonly " $data"?: PdpSharedAuctionActionCompletePurchase_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionCompletePurchase_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionActionCompletePurchase_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5df083ea1a39e8501c868a3f3ddee4d3";

export default node;
